module.exports = __webpack_public_path__ + "img/isaac_2.86a9e74b.png";